import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "activity-logs",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "activityLog" */ "./components"),
        import(
          /* webpackChunkName: "activityLog" */ "./modules/ActivityLogModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "activityLogs",
          reducer,
        });
        return component;
      });
    }),
  };
};
